<template>
  <v-card
  class="mx-auto my-5 mr-10 ml-10"
  
  >
  <v-card-title>
    {{this.question}}
  </v-card-title>

  <v-card-actions>
    <v-spacer></v-spacer>

    <v-btn
      icon
      @click="show = !show"
    >
      <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
    </v-btn>
  </v-card-actions>

  <v-expand-transition>
    <div v-show="show">
      <v-divider></v-divider>

      <v-card-text>
        {{this.answer}}
      </v-card-text>
    </div>
  </v-expand-transition>
  </v-card>
</template>

<script>
export default {
  props: ["question", "answer"],
  data: () => ({
    show: false,
  }),    
};
</script>